import { render, staticRenderFns } from "./campaignDetails.vue?vue&type=template&id=678984a4&"
import script from "./campaignDetails.vue?vue&type=script&lang=js&"
export * from "./campaignDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports